import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useSelector } from "react-redux";
import { Mixpanel } from "../../../config/Mixpanel";
import Constants from "../../../common/constants";

const points = [
  <>A Stand-Out Portfolio With A 93% Better CV </>,
  <span>
    Increase In Salary Up To <span className="font-bold text-white"> 200% </span>
    <img
      alt=""
      width={17}
      src="https://assets.learntube.ai/files/Certificate%20Verification%20Screen/spike.png?updatedAt=1750494807792"
      className="ml-1 inline-block"
    />
  </span>,
  <>3x Job Chances With Amazing Skills & Certificates</>,
];
const PersonaliseCard = ({handlerPersonalise}) => {
  const userDetails = useSelector(
    (store) => store?.certificateVerification?.userInfo
  );
  return (
    <div
      className="w-full flex flex-col items-center justify-start rounded-[16px] p-4"
      style={{ background: "rgba(66, 133, 244, 0.15)" }}
    >
      <div className="w-full flex items-center gap-3">
        <img
          src="https://assets.learntube.ai/files/Certificate%20Verification%20Screen/freepik__the-style-is-modern-and-it-is-a-detailed-illustrat__73803%201.png?updatedAt=1750488522086"
          alt=""
          className="w-[25%]"
        />
        <div className="flex flex-col justify-center">
          <div className="text-[16px] text-white md:text-[20px] font-semibold">
            Master This Subject For:
          </div>
          <div className="mt-3 flex flex-col gap-3">
            {points?.map((item, index) => (
              <div className="justiify-start flex items-center gap-[6px] text-[10px] md:text-[14px]  font-medium text-white/70">
                <FontAwesomeIcon
                  icon={faCheck}
                  className="text-[#2BBD13]"
                  size="xl"
                />
                {item}
              </div>
            ))}
          </div>
        </div>
      </div>
      <button className="mt-5 px-3 py-3 md:h-[52px] md:text-[18px] w-full cursor-pointer rounded-xl border-[2px] border-[#7FC241] text-[#7FC241] text-[16px] font-medium " onClick={(e)=> {
        Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_NORMAL_PAGE_BUILD_PERSONALIZED_COURSE_CLICKED);
        handlerPersonalise({utm_medium : 'build-course' , utm_source : 'certificate-verification'})}}>
       Build A Personalised Course
      </button>
      <div className="mt-2 underline underline-offset-2 font-medium text-[12px] md:text-[14px] text-[#7FC241] text-center cursor-pointer"  onClick={(e)=>{ 
        Mixpanel.track(Constants.Mixpanel.CERTIFICATE_VERIFICATION_NORMAL_PAGE_EXPLORE_1240_COURSES_CLICKED);
        handlerPersonalise({utm_medium : 'explore 1240+ courses' , utm_source : 'certificate-verification'})}}>Or Explore 1240+ Courses</div>
    </div>
  );
};

export default PersonaliseCard;
